import contentMixin from '@/components/helpers/mixins/content-mixin'

class MyUploadAdapter {
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader
  }

  // Starts the upload process.
  upload() {
    return this.loader.file
      .then((file) => new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          contentMixin.methods.$_contentMixin_addFN({ base: e.target.result.split(',')[1].substring(0, 100), name: file.name })
          resolve({
            default: e.target.result
          })
        }
        reader.readAsDataURL(file)
      }))
  }
}

export default MyUploadAdapter
